import {Fragment, useEffect, useState} from "react";
import {
    BreadCrumb, CenteredModal, FormInput, DropdownAction,
    SkeletonTableLoading, Table, HtmlCodeEditor
} from "~/components";
import {format} from "date-fns";
import {faEdit, faEye} from "@fortawesome/free-solid-svg-icons";
import NotiInAppTemplateAPI from '~/api/notiInAppTemplateApi';
import {useForm, Controller} from "react-hook-form";
import {toast} from "react-toastify";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
const breadCrumbItem = [
    { text: "Home", to: "/ai-chatbot/administrator", isActive: false },
    { text: "Noti InApp Template", to: "", isActive: true },
]

function NotiInAppTemplate() {
    const [reloadTable, setReloadTable] = useState(false);
    const [notiInAppTemplates, setNotiInAppTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const tableConfig = {
        columns: [
            {
                name: 'ID',
                width: '70px',
                className: 'fw-bold',
                key: 'NotiInAppTemplateId'
            },
            {
                name: 'EVENT NAME',
                width: '250px',
                key: 'EventName'
            },
            {
                name: 'Content',
                width: '250px',
                key: 'Content'
            },
            {
                name: 'MODIFIED BY',
                width: '150px',
                key: 'ModifiedBy'
            },
            {
                name: 'MODIFIED DATE',
                width: '150px',
                key: 'ModifiedDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.ModifiedDate), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'ACTION',
                width: '70px',
                key: 'Action',
                headerClassName: 'text-center',
                className: 'text-center',
                template: (row) => {
                    return (
                        <span><FontAwesomeIcon onClick={()=> handleShowActionModal(row.NotiInAppTemplateId)} icon={faEdit} className="text-primary cursor-pointer"/></span>
                    )
                }
            }
        ],
        tableKey: "TableNotiInAppTemplate",
        hasShowHideColumn: false
    }

    useEffect(() => {
        setLoading(true);
        NotiInAppTemplateAPI.getAll()
            .then((res) => {
                setNotiInAppTemplates(res.data);
            })
            .catch((err) => {
                ;
            })
            .finally(() => {
                setLoading(false);
            })
    }, [reloadTable]);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    const handleShowActionModal = (id) => {
        NotiInAppTemplateAPI.getById(id)
            .then((res) => {
                reset(res.data);
                setShowModal(true);
            })
            .catch((err) => {
                ;
            })
    }

    const onSubmitFrom = (data) => {
        NotiInAppTemplateAPI.update(data)
            .then((res) => {
                res.data?.Success ?
                    toast.success(<span className="fs-9 fw-bold">Your noti in app template has been updated.</span>)
                    : toast.error(<span className="fs-9 fw-bold">An error occurred while updating your noti in app template.</span>)
            })
            .catch((err) => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating your noti in app template.</span>)
            })
            .finally(() => {
                setShowModal(false);
                setReloadTable(pre => !pre)
                reset({
                    Content: ""
                })
            })
    }

    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-3">Noti InApp Template</h2>
            {loading ? (
                <SkeletonTableLoading columns={tableConfig.columns} rows={10} />
            ) : (
                <Table tableConfig={{...tableConfig, data : notiInAppTemplates}}/>
            )}
            <CenteredModal
                show={showModal}
                onClose={() => {
                    setShowModal(false)
                }}
                title="Edit Noti InApp Template"
                formId="formActionNotiInApp"
            >
                <form onSubmit={handleSubmit(onSubmitFrom)} id="formActionNotiInApp">
                    <div className="mb-3">
                        <FormInput showHeaderLabel={true}
                                   name = "Content"
                                   errors={errors}
                                   required={true}
                                   label="Assign content"
                                   validation={{...register("Content", {
                                           required: `Content is required.`
                                       })}}
                        />
                    </div>
                </form>
            </CenteredModal>
        </Fragment>
    )
}
export default NotiInAppTemplate;